import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from 'providers/auth'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import DropdownIndicatorIconOpened from 'assets/icons/dropdown-indicator-opened24px'
import MyProfileIcon from 'assets/icons/profile-icon'
import TermsIcon from 'assets/icons/terms-of-use-icon'
import PrivecyIcon from 'assets/icons/privacy-icon'
import SignOutIcon from 'assets/icons/sign-out-icon'
import { PROFILE_PATH, LEGAL_TERM_PATH } from 'routing/constants'

import {
  TopBarDropDownIconWrapper,
  TopBarDropdownItem,
  TopBarDropdownMenuWrapper,
  TopBarDropdownSignOutWrapper
} from './style'

const ProfileDropdown = () => {
  const [isOpenDropdownMenu, setIsOpenDropdownMenu] = useState(false)
  const [isActive, setIsActive] = useState('')
  const { logout } = useContext(AuthContext)
  const dropDownMenu = useRef()
  const dropdownIcon = useRef()
  const isLegalTerm = LEGAL_TERM_PATH === location.pathname

  const closeDropDownMenuOnOutsideClick = (e) => {
    if (dropDownMenu.current.contains(e.target) || dropdownIcon.current.contains(e.target)) {
      return
    }
    setIsOpenDropdownMenu(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', closeDropDownMenuOnOutsideClick)

    return () => {
      document.removeEventListener('mousedown', closeDropDownMenuOnOutsideClick)
    }
  }, [isOpenDropdownMenu])

  function openDropdownMenuHandler() {
    setIsOpenDropdownMenu(!isOpenDropdownMenu)
  }

  function changeItemHandler(e) {
    setIsActive(e.target.id)
    setIsOpenDropdownMenu(false)
  }

  return (
    <>
      <TopBarDropDownIconWrapper data-test="dropdown-trigger">
        <div ref={dropdownIcon} onClick={openDropdownMenuHandler}>
          {isOpenDropdownMenu ? <DropdownIndicatorIconOpened /> : <DropdownIndicatorIconClosed />}
        </div>
      </TopBarDropDownIconWrapper>
      <>
        <TopBarDropdownMenuWrapper style={{right: isLegalTerm ? '160px' : '', marginTop: isLegalTerm ? '17px' : ''}} data-test="user-settings-dropdown" ref={dropDownMenu} open={isOpenDropdownMenu}>
          <Link to={PROFILE_PATH} style={{textDecoration: 'none', color: '#202020'}}>
            <TopBarDropdownItem
              id="profile"
              active={isActive === 'profile'}
              onClick={changeItemHandler}
              data-test={isActive === 'profile' ? 'dropdown-active-item' : 'dropdown-item'}
            >
              <MyProfileIcon active={isActive === 'profile' ? 'rgba(10, 161, 244, 1)' : '#202020'} />
              <FormattedMessage id="profile" />
            </TopBarDropdownItem>
          </Link>
          <Link to={LEGAL_TERM_PATH} style={{textDecoration: 'none', color: '#202020'}}>
            <TopBarDropdownItem
              id="terms"
              active={isActive === 'terms'}
              onClick={changeItemHandler}
              data-test={isActive === 'terms' ? 'dropdown-active-item' : 'dropdown-item'}
            >
              <TermsIcon />
              <FormattedMessage id="terms" />
            </TopBarDropdownItem>
          </Link>
          <a href='https://www.birdlife.org/privacy-policy/' target="_blank" style={{textDecoration: 'none', color: '#202020'}} rel="noreferrer">
            <TopBarDropdownItem
              id="privacy"
              active={isActive === 'privacy'}
              onClick={changeItemHandler}
              data-test={isActive === 'privacy' ? 'dropdown-active-item' : 'dropdown-item'}
            >
              <PrivecyIcon />
              <FormattedMessage id="privacy" />
            </TopBarDropdownItem>
          </a>
          <TopBarDropdownSignOutWrapper onClick={logout}>
            <TopBarDropdownItem>
              <SignOutIcon />
              <FormattedMessage id="signOut" />
            </TopBarDropdownItem>
          </TopBarDropdownSignOutWrapper>
        </TopBarDropdownMenuWrapper>
      </>
    </>
  )
}

export default ProfileDropdown
